module.exports = __webpack_public_path__ + "0a2517b32073fb51366e58630e99a3ae.png";